import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import React, { useContext } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import NoData from './no-data';

var SearchPanel = function SearchPanel(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$keyword = _ref.keyword,
      keyword = _ref$keyword === void 0 ? '' : _ref$keyword,
      handleSelect = _ref.onSelect;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls;

  var cityPickerPrefixCls = getPrefixCls(prefixCls, 'city-picker');
  var containerCls = classNames("".concat(cityPickerPrefixCls, "-search-panel"));
  var hasData = data && data.length > 0;
  return /*#__PURE__*/React.createElement("div", {
    className: containerCls
  }, hasData ? _mapInstanceProperty(data).call(data, function (city) {
    var _context;

    var itemContainerCls = classNames("".concat(cityPickerPrefixCls, "-search-panel-item"));
    var itemLeftCls = classNames("".concat(cityPickerPrefixCls, "-search-panel-item-left"));
    var itemRightCls = classNames("".concat(cityPickerPrefixCls, "-search-panel-item-right"));

    var handleClick = function handleClick() {
      handleSelect === null || handleSelect === void 0 ? void 0 : handleSelect(city);
    };

    return /*#__PURE__*/React.createElement("div", {
      className: itemContainerCls,
      onClick: handleClick,
      key: city.id
    }, /*#__PURE__*/React.createElement("div", {
      className: itemLeftCls
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: city.name.replace(keyword, _concatInstanceProperty(_context = "<span class=\"".concat(cityPickerPrefixCls, "-search-keyword\">")).call(_context, keyword, "</span>"))
      }
    })), /*#__PURE__*/React.createElement("div", {
      className: itemRightCls
    }, /*#__PURE__*/React.createElement("span", null, city.province), /*#__PURE__*/React.createElement("span", null, city.country === '中国' ? '' : city.country)));
  }) : /*#__PURE__*/React.createElement(NoData, null));
};

export default SearchPanel;